import React from "react";
import Heading from "../components/common/Heading";
import Sliders from "../components/home/Slider";

export default function Testimonial() {
  return (
    <>
      <Heading heading="Testimonial" title="Home" subtitle="Testimonial" />
      <Sliders />
    </>
  );
}
